import { useEffect } from 'react'
import BrandLogo from '../Brand/BrandLogo'
import { brand } from '../../config/settings/brand'
import Portal from '../Basics/Portal'
import {
  Overlay,
  Content,
  BrandRow,
  BrandName,
  Spinner,
  Title,
  Subtitle,
} from './LogoutOverlay.styles'

const LogoutOverlay = ({
  title = 'Cerrando sesión…',
  subtitle = 'Te llevamos de vuelta al inicio.',
}) => {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = previousOverflow
    }
  }, [])

  return (
    <Portal>
      <Overlay role="status" aria-live="polite" aria-busy="true">
        <Content>
          <BrandRow>
            <BrandLogo size={36} />
            <BrandName>{brand.name}</BrandName>
          </BrandRow>
          <Spinner aria-hidden />
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
        </Content>
      </Overlay>
    </Portal>
  )
}

export default LogoutOverlay
